/**
 * CDN base used for logos, illustrations and favicons when the env-backed
 * RESOURCES_URL is unavailable on the error path (i.e. when the loader produced
 * no data). Mirrors the production resources bucket.
 */
export const DEFAULT_RESOURCES_URL = 'https://cx-resources.oddschecker.com/public';
